import { render } from "./RoomInstructions.vue?vue&type=template&id=0bd5ccc8&scoped=true&ts=true"
import script from "./RoomInstructions.vue?vue&type=script&lang=ts"
export * from "./RoomInstructions.vue?vue&type=script&lang=ts"

import "./RoomInstructions.vue?vue&type=style&index=0&id=0bd5ccc8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bd5ccc8"]])

export default __exports__